import React from 'react';
import Grid from '../Grid';
import { HeroStyled, TextHeader, Headline, HighLightText, Tag, ImageBlock, Button } from './styled';

import uLIcon from './ul-hero-icon.svg';

const Hero = () => {
  return (
    <HeroStyled>
      <Grid>
        <TextHeader>
          <Tag>
            <img
              src="https://cdn.auth0.com/website/machine-to-machine/img/hero/m2m-hero-icon.svg"
              alt="Machine to Machine"
            />
            <h2>MACHINE-TO-MACHINE COMMUNICATION</h2>
          </Tag>
          <Headline>
            Simplify Communication Between APIs and <br />Trusted Services
          </Headline>
          <HighLightText>
            Easily handle authentication and authorization for non-interactive applications ranging
            from IoT and trusted subsystem interactions to daemons
          </HighLightText>
          <Button href="javascript:signup()" className="btn btn-success btn-lg">
            Get Started
          </Button>
          <Button
            href="https://auth0.com/docs/applications/machine-to-machine"
            className="btn btn-transparent btn-lg white"
          >
            Read The Docs
          </Button>
        </TextHeader>
        <ImageBlock>
          <video
            muted={'true'}
            autoPlay={'true'}
            loop={'true'}
            src="https://videos.ctfassets.net/uv3ln4emu9ke/1vRvqD3qxWKYggiU0CY8iw/250ba01db0e398c05af1d039b75b8200/hero-animation__1_.mp4"
          />
          <img
            src="https://cdn.auth0.com/website/machine-to-machine/image/hero/hero-image.svg"
            alt="Simplify Communication Between APIs and Trusted Services"
          />
        </ImageBlock>
      </Grid>
    </HeroStyled>
  );
};

export default Hero;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Hero/Hero.js